import { render, staticRenderFns } from "./formTaskProcessViewer.vue?vue&type=template&id=9234498c&"
import script from "./formTaskProcessViewer.vue?vue&type=script&lang=js&"
export * from "./formTaskProcessViewer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports